import type { EditorItem } from '../../Reducers/Configurator/types';

/**
 * Hit-layer order (bottom → top): all non-selected items in insertion order,
 * then the selected item last, so it always wins a click/drag on any overlap.
 */
export function orderItemsForHit(
  items: Record<string, EditorItem>,
  selectedId: string | null,
): EditorItem[] {
  const all = Object.values(items);
  return [
    ...all.filter((i) => i.id !== selectedId),
    ...all.filter((i) => i.id === selectedId),
  ];
}
